import { useNavigate } from "react-router-dom";
import bgImg5 from "../../assets/images/communication/COMMUNICATION.webp";
import Hero from "../../Components/HeroIndustries/HeroIndustries";
import { ServiceCardView } from "../../Components/ServiceCardView";
const Index = () => {
  const navigate = useNavigate();

  return (
    <>
      <Hero
        pageName="SERVICES / ENTERPRISE AI"
        pageIntro="Unlock business potential with cutting-edge AI, from generative workflows to multi-modal intelligence."
        pageIntroPara={""}
        alt="img"
        image={bgImg5}
      />

      <ServiceCardView
        list={[
          {
            id: "generative-ai",
            title: "Generative AI & Agentic Workflows",
            desc: "Transform operations with generative AI, automating workflows and creating personalized content to drive efficiency and engagement.",
            technologies: "LangChain, AutoGen, GPT-4, DALL·E",
            features: [
              "Self-optimizing workflows",
              "Personalized content generation",
              "Real-time process adaptation",
              "Multilingual support",
            ],
            impact:
              "40% cost reduction, 30% faster processes, 25% higher engagement",
            caseStudy: {
              client: "Global Retail Chain",
              challenge:
                "Manual inventory management and marketing content creation led to delays and inconsistent customer experiences.",
              solution:
                "NucleusTeq deployed generative AI using LangChain and GPT-4 to automate inventory updates and generate personalized marketing emails.",
              outcome:
                "Reduced inventory processing time by 35% and boosted email campaign engagement by 20%.",
            },
            imagePrompt: {
              description:
                "A futuristic retail warehouse with robotic arms sorting inventory, overlaid with a digital dashboard showing real-time data and personalized email templates. Use blue shades (#007BFF, #E6F0FA) for a clean, modern look.",
              style: "Professional, sci-fi, digital art, 800x400px",
              altText:
                "Retail warehouse with AI-driven inventory and marketing automation",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "multi-modal-ai",
            title: "Multi Modal AI Development",
            desc: "Create AI systems integrating vision, audio, and code generation for versatile, intelligent applications across industries.",
            technologies: "OpenCV, YOLO, Whisper, GitHub Copilot, TensorFlow",
            features: [
              "Vision-based object detection",
              "Audio processing and transcription",
              "Automated code generation",
              "Multi-modal integration",
            ],
            impact:
              "35% improved application versatility, 25% faster development cycles",
            caseStudy: {
              client: "Media Technology Company",
              challenge:
                "Manual content analysis and software development slowed production of multimedia applications.",
              solution:
                "NucleusTeq developed a multi-modal AI system using YOLO for video content analysis, Whisper for audio transcription, and GitHub Copilot for rapid code generation, streamlining multimedia app development.",
              outcome:
                "Reduced content analysis time by 40% and accelerated app development by 30%.",
            },
            imagePrompt: {
              description:
                "A media production studio with a dashboard displaying video analysis, audio transcripts, and generated code snippets. Use blue and white (#007BFF, #E6F0FA) for a modern, tech-driven design.",
              style: "Media, futuristic, digital art, 800x400px",
              altText:
                "Media dashboard with multi-modal AI for content and code generation",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "conversational-ai",
            title: "Conversational AI Development",
            desc: "Enhance customer interactions with intelligent chatbots, delivering faster responses and personalized support.",
            technologies:
              "Google Dialogflow, Microsoft Bot Framework, Hugging Face",
            features: [
              "Natural language processing",
              "Multi-channel integration",
              "Context-aware responses",
              "Scalable deployments",
            ],
            impact:
              "50% faster response times, 20% higher customer satisfaction",
            caseStudy: {
              client: "H&M (Retail)",
              challenge:
                "High inquiry volumes overwhelmed support teams, causing long wait times.",
              solution:
                "NucleusTeq implemented a chatbot using Microsoft Bot Framework, integrated across H&M’s website and social platforms, for inquiries and recommendations.",
              outcome:
                "Cut response time from 10 minutes to 30 seconds, improved satisfaction by 15%.",
            },
            imagePrompt: {
              description:
                "A retail website interface with a chatbot window displaying a customer query and product recommendations. Use a blue gradient (#E6F0FA to #007BFF) with modern typography.",
              style: "Minimalist, UI-focused, digital art, 800x400px",
              altText: "Retail chatbot interface for customer support",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "ml-engineering",
            title: "ML Engineering",
            desc: "Build custom ML models for predictive maintenance and fraud detection, ensuring high accuracy and operational efficiency.",
            technologies: "TensorFlow, PyTorch, Scikit-learn",
            features: [
              "Tailored model development",
              "Real-time predictions",
              "High-accuracy algorithms",
              "Scalable architectures",
            ],
            impact: "95%+ prediction accuracy, 40% reduced downtime",
            caseStudy: {
              client: "Siemens (Manufacturing)",
              challenge:
                "Unplanned equipment failures increased maintenance costs and production delays.",
              solution:
                "NucleusTeq developed a TensorFlow-based predictive maintenance model analyzing sensor data to forecast equipment issues.",
              outcome: "Reduced downtime by 30% and maintenance costs by 25%.",
            },
            imagePrompt: {
              description:
                "A high-tech manufacturing facility with sensors on machinery, connected to a dashboard showing predictive maintenance alerts. Use blue and white tones (#003087, #FFFFFF) for a futuristic design.",
              style: "Industrial, sci-fi, digital art, 800x400px",
              altText:
                "Manufacturing facility with AI-driven predictive maintenance",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "industry-ai",
            title: "Industry-Specific AI Solutions",
            desc: "Deploy tailored AI models for sectors like manufacturing and BFSI, optimizing processes while meeting regulatory standards.",
            technologies: "TensorFlow, PyTorch, industry frameworks",
            features: [
              "Domain-specific models",
              "Regulatory compliance",
              "Process automation",
              "Scalable solutions",
            ],
            impact: "30% efficiency gains, 20% cost reduction",
            caseStudy: {
              client: "Major Bank (BFSI)",
              challenge:
                "Rising fraudulent transactions strained manual detection efforts.",
              solution:
                "NucleusTeq built a PyTorch-based fraud detection model, integrated with transaction systems for real-time anomaly detection.",
              outcome: "Detected 90% of fraud, reduced losses by 35%.",
            },
            imagePrompt: {
              description:
                "A banking dashboard with real-time fraud alerts, graphs, and transaction data. Use blue and white (#007BFF, #FFFFFF) for a secure, professional aesthetic.",
              style: "Corporate, data-driven, digital art, 800x400px",
              altText: "Banking dashboard with AI-powered fraud detection",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "ai-strategy",
            title: "AI Strategy Consulting",
            desc: "Develop AI roadmaps and identify high-impact use cases to accelerate adoption and drive business value.",
            technologies: "Design Thinking, AI Canvas, strategic frameworks",
            features: [
              "Custom AI roadmaps",
              "High-value use case identification",
              "Proof-of-concept development",
              "Adoption strategies",
            ],
            impact: "50% faster AI adoption, 25% ROI increase",
            caseStudy: {
              client: "Global Logistics Firm",
              challenge:
                "Lack of a clear AI strategy slowed adoption and value realization.",
              solution:
                "NucleusTeq conducted Design Thinking workshops to identify predictive logistics use cases, creating a TensorFlow-based PoC roadmap.",
              outcome:
                "Accelerated AI adoption by 40%, improved logistics efficiency by 20%.",
            },
            imagePrompt: {
              description:
                "A workshop scene with professionals sketching AI strategy roadmaps on a whiteboard, with digital logistics icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Corporate, collaborative, digital art, 800x400px",
              altText: "Workshop designing AI strategy for logistics",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "generative-bi",
            title: "Generative BI",
            desc: "Unlock strategic insights with AI-driven predictive dashboards and automated reporting, boosting revenue and decision speed.",
            technologies:
              "Power BI, Tableau, TensorFlow, Azure ML, Superset, Python",
            features: [
              "Predictive analytics",
              "Interactive dashboards",
              "Automated reports",
              "Real-time insights",
            ],
            impact: "20-30% revenue growth, 70% faster reporting",
            caseStudy: {
              client: "E-commerce Platform",
              challenge:
                "Delayed sales reporting hindered timely strategic decisions.",
              solution:
                "NucleusTeq implemented a generative BI solution with Power BI and TensorFlow, delivering predictive sales dashboards and automated reports.",
              outcome: "Cut reporting time by 65%, increased revenue by 22%.",
            },
            imagePrompt: {
              description:
                "An e-commerce dashboard with predictive sales trends, charts, and automated reports. Use blue and white (#007BFF, #FFFFFF) for a clean, data-centric design.",
              style: "Data-driven, modern, digital art, 800x400px",
              altText: "E-commerce dashboard with AI-driven analytics",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "ai-compliance",
            title: "Gen AI & ML Compliance",
            desc: "Ensure ethical AI with compliance frameworks, bias mitigation, and transparent models for regulatory adherence.",
            technologies:
              "Watson OpenScale, Fairlearn, SHAP, LIME, Collibra, Alation",
            features: [
              "Audit trails",
              "Bias detection",
              "Explainable models",
              "GDPR/CCPA compliance",
            ],
            impact: "99.9% compliance, 20% reduced regulatory risk",
            caseStudy: {
              client: "Healthcare Provider",
              challenge:
                "AI diagnostics required strict HIPAA compliance to avoid penalties.",
              solution:
                "NucleusTeq deployed a compliance framework with Watson OpenScale and SHAP, ensuring transparent, bias-free diagnostic models.",
              outcome: "Achieved 100% HIPAA compliance, reduced risks by 30%.",
            },
            imagePrompt: {
              description:
                "A healthcare dashboard with AI diagnostic results, compliance badges (HIPAA, GDPR), and transparency metrics. Use blue and white (#003087, #FFFFFF) for a secure look.",
              style: "Healthcare, compliant, digital art, 800x400px",
              altText: "Healthcare dashboard with AI compliance framework",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "mlops",
            title: "ML/LLM Ops",
            desc: "Streamline AI operations with automated pipelines and monitoring, ensuring high uptime and rapid deployments.",
            technologies: "MLflow, Kubeflow, Prometheus, Grafana",
            features: [
              "Automated pipelines",
              "Real-time monitoring",
              "Continuous integration",
              "High-availability operations",
            ],
            impact: "50% faster deployments, 99.9% uptime",
            caseStudy: {
              client: "Telecom Provider",
              challenge:
                "Model deployment delays disrupted AI-driven network optimization.",
              solution:
                "NucleusTeq implemented an MLOps pipeline with MLflow and Prometheus, automating deployments and monitoring for network analytics.",
              outcome: "Reduced deployment time by 45%, achieved 99.8% uptime.",
            },
            imagePrompt: {
              description:
                "A telecom control room with a dashboard showing network analytics and MLOps pipeline status. Use blue gradient (#E6F0FA to #007BFF) for a high-tech aesthetic.",
              style: "Telecom, futuristic, digital art, 800x400px",
              altText: "Telecom dashboard with MLOps for network optimization",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "llm-deployment",
            title: "LLM Deployment",
            desc: "Deploy large language models on cloud platforms for scalable, high-performance AI applications.",
            technologies: "LLaMA, BERT, AWS Bedrock, Google Vertex AI",
            features: [
              "Scalable deployments",
              "Cloud-native integration",
              "High-performance models",
              "Secure operations",
            ],
            impact: "40% faster deployments, 30% cost savings",
            caseStudy: {
              client: "Uber (Transportation)",
              challenge:
                "Scaling LLM-powered services for support and recommendations was costly.",
              solution:
                "NucleusTeq deployed LLaMA on AWS Bedrock, optimizing Uber’s chatbots and recommendation systems.",
              outcome:
                "Cut deployment costs by 35%, improved response times by 25%.",
            },
            imagePrompt: {
              description:
                "A transportation app interface with an LLM-powered chatbot and recommendation panel. Use blue and white (#007BFF, #FFFFFF) for a modern, user-friendly design.",
              style: "Transportation, UI-focused, digital art, 800x400px",
              altText: "Transportation app with LLM-powered chatbot",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "predictive-analytics",
            title: "Predictive Analytics Solutions",
            desc: "Develop predictive models to forecast trends and drive strategic decisions with high accuracy.",
            technologies: "TensorFlow, Azure ML, Python",
            features: [
              "Predictive modeling",
              "Real-time analytics",
              "Scalable solutions",
              "Business integration",
            ],
            impact: "25% higher sales, 40% faster insights",
            caseStudy: {
              client: "Online Retail Company",
              challenge:
                "Inaccurate demand forecasting led to overstocking and lost sales opportunities.",
              solution:
                "NucleusTeq built a TensorFlow-based predictive analytics model to forecast demand, integrated with the retailer’s inventory system.",
              outcome:
                "Improved forecast accuracy by 30%, increased sales by 20%.",
            },
            imagePrompt: {
              description:
                "An online retail dashboard showing demand forecasts, inventory levels, and sales trends. Use blue and white (#007BFF, #FFFFFF) for a data-driven, modern design.",
              style: "Retail, data-centric, digital art, 800x400px",
              altText:
                "Retail dashboard with predictive analytics for demand forecasting",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "model-monitoring",
            title: "Model Monitoring & Retraining",
            desc: "Monitor and retrain AI models in real-time to maintain performance and adapt to changing data patterns.",
            technologies: "Prometheus, Grafana, MLflow",
            features: [
              "Real-time monitoring",
              "Automated retraining",
              "Performance tracking",
              "Anomaly detection",
            ],
            impact: "30% improved model accuracy, 20% reduced downtime",
            caseStudy: {
              client: "Insurance Firm",
              challenge:
                "Degrading model performance in claims prediction led to inaccurate risk assessments.",
              solution:
                "NucleusTeq implemented a monitoring solution with Prometheus and Grafana, enabling real-time performance tracking and automated retraining.",
              outcome:
                "Improved model accuracy by 25%, reduced prediction errors by 15%.",
            },
            imagePrompt: {
              description:
                "An insurance dashboard with real-time model performance metrics, alerts, and retraining status. Use blue gradient (#E6F0FA to #007BFF) for a professional, data-driven look.",
              style: "Insurance, analytical, digital art, 800x400px",
              altText:
                "Insurance dashboard with AI model monitoring and retraining",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
        ]}
        buttunData={{
          buttonText: "Schedule a Consultation",
          buttonAction: () => {
            navigate("/contact");
          },
        }}
      />
    </>
  );
};

export default Index;
